module.exports = __webpack_public_path__ + "static/a-feast-for-crows-3f7f33693a3e7568f965d2c3de3b8816.jpg";